
<form [formGroup]="formG1">


	<div>
		<triv-input [fGroup]="formG1" [data]="myInputs.name"></triv-input>

		<div
			*ngIf="bIsDuplicate"
			class="uniqueMsg"
		>
			<span class="material-icons" style="vertical-align: bottom;">report_problem</span>
			Eine andere Gruppe hat bereits diesen Namen!
		</div>

	</div>

	<triv-input [fGroup]="formG1" [data]="myInputs.enabled"></triv-input>

	<triv-input [fGroup]="formG1" [data]="myInputs.userSubscribable"></triv-input>

	<triv-input [fGroup]="formG1" [data]="myInputs.chatGroup"></triv-input>

	<!--
	<div>
		<ul>
			<li *ngFor="let user of group.users">
				{{user}}
			</li>
		</ul>
	</div>
	-->



	<div 
		*ngIf="!group.vgId"
		style="margin-top: 4em; display: flex; flex-flow: row; justify-content: flex-end; gap: 2em;"
	>

		<button
			*ngIf="!group.vgId"
			mat-raised-button 
			[disabled]="bInProgress"
			(click)="cancel()"
		>
			<span class="material-icons">undo</span>
			Abbrechen
		</button>

		<!--
		<button mat-raised-button 
			[disabled]="formG1.pristine || bInProgress"
			(click)="reset()"
		>
			<span class="material-icons">history</span>
			Zurücksetzen
		</button>
		-->

		<button
			mat-raised-button
			color="primary" 
			(click)="save()" 
			[disabled]="!formG1.valid || formG1.pristine || bInProgress"
		>
			<span class="material-icons">save</span>
			Erstellen
		</button>

	</div>

</form>
